import { useContext, useEffect, useRef, useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import { MdAdd, MdApproval } from "react-icons/md";
import { useParams } from "react-router-dom";
import Wrapper from "../../components/shared/Wrapper";
import BackToolnav from "../../components/toolnav/BackToolnav";
import fetchDataClaim from "../../services/fetchDataClaim";
import CreateItem from "./components/CreateItem";
import pht_avatar from "../../assets/images/photo.png";
import pdf_avatar from "../../assets/images/pdf.png";
import { BsCheck2Square, BsDownload, BsEye, BsEyeFill } from "react-icons/bs";
import formatSize from "../../utils/formatSize";
import DeleteItem from "./components/DeleteItem";
import ApproveClaim from "./components/ApproveClaim";
import { claimStatus } from "../../utils/data";
import Moment from "react-moment";
import UpdateItem from "./components/UpdateItem";
import Document from "./components/Document";
import DocumentWrapper from "../../components/docum/DocumentWrapper";
import { useReactToPrint } from "react-to-print";
import { GrUpload } from "react-icons/gr";
import {
  AiOutlineCheckSquare,
  AiOutlineCloseSquare,
  AiOutlinePrinter,
} from "react-icons/ai";
import NoResults from "../../components/shared/NoResults";
import { AuthContext } from "../../contexts/AuthContext";
import SubmitClaim from "./components/SubmitClaim";
import { TbRefresh } from "react-icons/tb";
import LoadingClaim from "./components/LoadingClaim";
import { HiOutlineTrash } from "react-icons/hi";
import DeleteClaim from "./components/DeleteClaim";
import UploadFile from "./components/UploadFile";

export default function OneClaim() {
  const { user } = useContext(AuthContext);
  const [claim, setClaim] = useState<any>([]);
  const [selectedItem, setSelectedItem] = useState<any>({});
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [submitModal, setSubmitModal] = useState<boolean>(false);
  const [approveModal, setApproveModal] = useState<boolean>(false);
  const [updateItemModal, setUpdateItemModal] = useState<boolean>(false);
  const [deleteItemModal, setDeleteItemModal] = useState<boolean>(false);
  const [documentModal, setDocumentModal] = useState<boolean>(false);
  const [itemFileModal, setItemFileModal] = useState<boolean>(false);
  const [isEditable, setEditable] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>({});
  const [preview, setPreview] = useState<any>("");

  const deleters = ["amahmoud@toyota.co.tz"];
  const docRef = useRef(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  let { claim_id } = useParams();

  const handleFetchClaim = async () => {
    setLoading(true);
    const uri = `claim/${claim_id}`;
    const response = await fetchDataClaim({ uri });
    setClaim(response?.payload);
    setLoading(false);
  };

  const handleReFetchClaim = async () => {
    const uri = `claim/${claim_id}`;
    const response = await fetchDataClaim({ uri });
    setClaim(response?.payload);
    setLoading(false);
  };

  const getTotal = (items: any) => {
    let total = 0;
    items?.forEach((item: any) => {
      total = total + item?.amount;
    });
    return total;
  };

  const total = getTotal(claim?.items);

  const attachments = claim?.items?.filter(
    (item: any) => item?.hasReceipt === true
  );

  useEffect(() => {
    handleFetchClaim();
  }, []);

  if (isLoading || claim === undefined) {
    return <LoadingClaim />;
  }

  return (
    <>
      <BackToolnav />
      <Wrapper
        title={`${claim?.claimer?.name}`}
        subtitle={`${claim?.expense_month}`}
        description={
          <>
            <span
              style={{
                background: claimStatus[claim?.status],
                padding: 4,
                borderWidth: 1,
                marginRight: 4,
              }}
            >
              {claim?.status}
            </span>
            Created : {<Moment fromNow>{claim?.createdAt}</Moment>}
          </>
        }
        actions={
          <div className="flex justify-center items-center text-sm">
            {claim?.isFinished ? null : (
              <div className="flex">
                <button
                  className="flex justify-center items-center border p-2 mr-2"
                  onClick={() => setCreateModal(true)}
                >
                  <div className="">
                    <MdAdd />
                  </div>
                  <div className="ml-1">Add Item</div>
                </button>

                <button
                  onClick={() => handleFetchClaim()}
                  className={`flex justify-center items-center border p-2`}
                >
                  <div className="">
                    <TbRefresh />
                  </div>
                  <div className="ml-1">Refresh</div>
                </button>
                <button
                  onClick={() => setEditable(!isEditable)}
                  className={`flex justify-center items-center border p-2 ml-2 ${isEditable ? "bg-yellow-100" : ""
                    }`}
                >
                  <div className="">
                    <FaRegEdit />
                  </div>
                  <div className="ml-1">Edit Mode</div>
                </button>

                {deleters?.includes(user?.email) ? null : (
                  <button
                    className="flex justify-center items-center border p-2 ml-2"
                    onClick={() => setDeleteModal(true)}
                  >
                    <div className="">
                      <HiOutlineTrash color="red" />
                    </div>
                    <div className="ml-1">Delete</div>
                  </button>
                )}

                <button
                  onClick={() => setSubmitModal(true)}
                  className={`flex justify-center items-center border p-2 ml-2 bg-green-50
              `}
                >
                  <div className="">
                    <BsCheck2Square />
                  </div>
                  <div className="ml-1">Submit</div>
                </button>
              </div>
            )}

            {deleters.includes(user?.email) && (
              <>
                {claim?.status === "Approved" ? null : (
                  <button
                    className="flex justify-center items-center border p-2 ml-2"
                    onClick={() => setDeleteModal(true)}
                  >
                    <div className="">
                      <HiOutlineTrash color="red" />
                    </div>
                    <div className="ml-1">Delete</div>
                  </button>
                )}
              </>
            )}
            {user?.accessLevel === 5 ? (
              <button
                className="flex justify-center items-center border p-2 ml-2"
                onClick={() => setApproveModal(true)}
              >
                <div className="">
                  <MdApproval />
                </div>
                <div className="ml-1">Approve</div>
              </button>
            ) : null}

            {isEditable ? null : (
              <button
                onClick={() => reactToPrintFn()}
                className="flex justify-center border p-2 items-center focus:outline-none  mr-2 text-sm hover:text-toyota"
              >
                <AiOutlinePrinter className="mr-1" /> Print
              </button>
            )}
          </div>
        }
      >
        <div>
          <div className="flex flex-row bg-whitish overflow-auto">
            <div className="grid grid-cols-12 gap-0 bg-gray-50 w-full">
              <div className="col-span-12 sm:col-span-9">
                <div className="flex justify-start ml-10">
                  <div className="book" ref={contentRef}>
                    <div className="page" ref={docRef}>
                      <div className="subpage">
                        {isLoading ? null : (
                          <DocumentWrapper
                            statements={2}
                            selected={selected}
                            claim={claim}
                            getTotalDue={() => { }}
                            setSelected={setSelected}
                            isEditable={isEditable}
                            updateItemModal={updateItemModal}
                            setUpdateItemModal={setUpdateItemModal}
                            deleteItemModal={deleteItemModal}
                            setDeleteItemModal={setDeleteItemModal}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-12 sm:col-span-3 bg-white border-l px-6">
                <div className="flex border-b-2 py-2">
                  <div className="flex items-center justify-center">
                    <div className="pb-1">Submitted:</div>
                    <div className="ml-2">
                      {claim?.isFinished ? (
                        <AiOutlineCheckSquare color="#33cc33" />
                      ) : (
                        <AiOutlineCloseSquare color="#E50000" />
                      )}
                    </div>
                  </div>

                  <div className="flex items-center ml-4">
                    <div className="pb-1">Approval:</div>
                    <div className="ml-2">
                      {claim?.status === "Approved" ? (
                        <AiOutlineCheckSquare color="#33cc33" />
                      ) : null}
                      {claim?.status === "Declined" ? (
                        <AiOutlineCloseSquare color="#E50000" />
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className=" border-b py-4">Attachments : </div>

                <div className="">
                  {attachments?.length === 0 ? (
                    <div className="mt-12">
                      <NoResults title={"No Attachments"} />
                    </div>
                  ) : null}
                  {attachments?.map((item: any, index: number) => (
                    <div className="flex justify-between mt-2" key={index}>
                      <div className="flex">
                        <div className="mr-2">
                          <img
                            src={
                              item.filetype === "application/pdf"
                                ? pdf_avatar
                                : pht_avatar
                            }
                            alt="Logo"
                            height={15}
                            width={35}
                          />
                        </div>
                        <div className="flex flex-col justify-center">
                          <div className="">{item?.category}</div>
                          <div className="flex items-center text-xs">
                            <span className="w-16">
                              {formatSize(item?.filesize)}
                            </span>
                            <button
                              onClick={() => {
                                setSelectedItem(item);
                                setItemFileModal(true);
                              }}
                              className="flex items-center"
                            >
                              <GrUpload size={10} />{" "}
                              <span className="ml-1">Re-Upload</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-center items-center">
                        {item?.filetype === "application/pdf" ? (
                          <a
                            href={`${item?.attachment}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="ml-4 hover:text-green-600 text-black"
                          >
                            <BsDownload />
                          </a>
                        ) : (
                          <>
                            {preview?._id === item?._id ? (
                              <button
                                onClick={() => setPreview("")}
                                className=""
                              >
                                <BsEyeFill color="#16a34a" />
                              </button>
                            ) : (
                              <button
                                onClick={() => setPreview(item)}
                                className=""
                              >
                                <BsEye />
                              </button>
                            )}
                            <a
                              href={item?.attachment}
                              target="_blank"
                              rel="noopener noreferrer"
                              download={true}
                              className="ml-2 text-black"
                            >
                              <button>
                                <BsDownload />
                              </button>
                            </a>
                          </>
                        )}
                      </div>
                    </div>
                  ))}
                  {preview ? (
                    <div className="border p-1 mt-4">
                      {preview?.filetype === "application/pdf" ? (
                        <div className="">
                          <a href={`${preview?.attachment}`} target="_black">
                            Pdf
                          </a>
                        </div>
                      ) : (
                        <img src={`${preview?.attachment}`} alt="" />
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Wrapper>

      <CreateItem
        isVisible={createModal}
        setVisible={setCreateModal}
        selected={claim}
        refetch={handleReFetchClaim}
      />

      <DeleteItem
        isVisible={deleteItemModal}
        setVisible={setDeleteItemModal}
        selected={selected}
        claim={claim}
        refetch={handleReFetchClaim}
      />

      <UpdateItem
        isVisible={updateItemModal}
        setVisible={setUpdateItemModal}
        selected={selected}
        claim={claim}
        refetch={handleFetchClaim}
      />

      <Document
        isVisible={documentModal}
        setVisible={setDocumentModal}
        selected={selected}
        claim={claim}
        refetch={handleReFetchClaim}
      />

      <ApproveClaim
        isVisible={approveModal}
        setVisible={setApproveModal}
        selected={selected}
        claim={claim}
        refetch={handleReFetchClaim}
        total={total}
      />

      <SubmitClaim
        isVisible={submitModal}
        setVisible={setSubmitModal}
        selected={selected}
        claim={claim}
        refetch={handleReFetchClaim}
        total={total}
      />

      <DeleteClaim
        isVisible={deleteModal}
        setVisible={setDeleteModal}
        selected={claim}
        claim={claim}
        refetch={handleReFetchClaim}
      />

      <UploadFile
        isVisible={itemFileModal}
        setVisible={setItemFileModal}
        selectedItem={selectedItem}
        claim={claim}
        refetch={handleReFetchClaim}
      />
    </>
  );
}
